import React from 'react'
import { connect } from 'react-redux'
import {  Row,  Table } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'
import * as XLSX from 'xlsx';

import {getUserInfoAccounts} from '../../../actions/user-actions';
import { NO_SEARCH_RESULTS } from '../../messages'


class UserInfoOverview extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, isSearching: false }
      }

      componentDidMount() {
        if(this.props.query) {
          this.setState({ query: this.props.query })
        }
      }

      componentWillUnmount() {
         this.setState({ query: undefined })
      }

      search(query) {
        this.setState({ query, overViewmode: true, isSearching: true })
        this.props.getUserInfoAccounts(query).then(() => {
          this.setState({ isSearching: false })
        })
      }

      openInNewTab(url) {
        window.open(url, '_blank').focus();
      }

    
      render() {
        const { userResults, query } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Actieve accounts" 
            />
            <Row >
              <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
                <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                  Zoek actieve accounts op basis van voornaam, achternaam, email of SSO ID’s
                  </div>
                  <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                  placeholder=""
                  value={ this.state.query || this.props.query }
                  callback={(query) => this.search(query)}
                  isLoading={this.state.isSearching}
                  />
              </div>
            </Row>
          </Row>
          <Row>
            <div className="tablescontainer" style={{marginTop:"5px"}}>
              { userResults && userResults.length? (
                <Table striped>
                  <thead style={{borderTop:"1px solid black", background:"none"}}>
                    <tr style={{borderTop:"1px solid black", background:"none", color:"black"}}>
                      <th style={{width:"33%"}}>Voornaam</th>
                      <th style={{width:"33%"}} >Achternaam</th>
                      <th style={{width:"33%"}} >E-mail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userResults.map((product, index) => (
                      <tr key={index} onClick={() => this.openInNewTab(product.url)} >
                      <td style={{width:"33%"}} >{product.firstName}</td>
                      <td style={{width:"33%"}}>{product.lastName ? product.lastName : ""}</td>
                      <td style={{width:"33%"}}>{product.email ? product.email : ""}</td>
                    </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div />
              )}
            </div>
          </Row>
        </div>
      }

    
}


  export default connect((state) => {
    return { 
    userResults: state.dashboard.userLicenseSearchDashboard.results,
    query: state.dashboard.userLicenseSearchDashboard.query
  }}, {
    getUserInfoAccounts,
  })(UserInfoOverview)